import { Component, ViewChild, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController, ModalController, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { ArticlesServices } from '../services';
import { StaticsServices } from '../../services/statics';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ConfigurationServices } from '../../configuration/services';

/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-articles-update-prices',
  templateUrl: 'articles-update-prices.html',
})
export class ArticlesUpdatePricesPage implements OnInit, OnDestroy {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  // Propiedades para ngx-datatable
  loadingIndicator = false;
  sorts = [];

  getRowClass = (row: any) => {
    return {
      'selected-row': row.selected
    };
  }

  onSort(event: any) {
    // Implementar ordenamiento si es necesario
  }

  elements_og = [];
  elements = [];
  selectAll = false;
  massiveColor: any = null;
  massiveCategories = '';
  massiveCategorySearchResults: string[] = [];
  massiveSelectedCategories: string[] = [];
  massiveRemovedCategories: string[] = [];
  massiveComplements = '';
  massiveComplementSearchResults: any[] = [];
  massiveSelectedComplements: any[] = [];
  massiveRemovedComplements: any[] = [];
  massivePrice: any = null;
  massivePrice2: any = null;
  massivePrice3: any = null;
  massivePriceOnline: any = null;
  massivePosActive: boolean | null = null;
  massiveFavourite: boolean | null = null;
  hasCommonValuesDetected: boolean = false;
  lastSelectedCount: number = 0;
  manualChangesMade: boolean = false;

  colors: any[] = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public articlesServices: ArticlesServices,
    public staticsServices: StaticsServices,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    private cdr: ChangeDetectorRef) {
    this.elements_og = this.navParams.get('elements');
    // elements_working es la copia profunda donde se hacen todas las modificaciones
    this.elements_working = JSON.parse(JSON.stringify(this.navParams.get('elements')));
    // elements apunta inicialmente a todo el array de trabajo
    this.elements = this.elements_working;

    // Cargar grupos de complementos disponibles
    this.configurationServices.getComplementsGroups();

    // NO inicializar propiedades aquí - los colores aún no están cargados
    // Se inicializarán en loadColors() después de que los colores estén disponibles

    // Inicializar campos de precios como undefined para que los inputs estén vacíos
    this.elements_working.forEach(element => {
      if (element.type === 'dish') {
        // Para platos, inicializar como undefined
        element.new_price = undefined;
        element.new_price_half = undefined;
        element.new_price_tapa = undefined;
        element.new_price_takeaway = undefined;
      } else {
        // Para productos, inicializar como undefined
        element.new_pvp = undefined;
        element.new_pvp2 = undefined;
        element.new_pvp3 = undefined;
        element.new_pvp_takeaway = undefined;
      }
    });
  }

  ngOnInit() {
    // Cargar colores después de que el servicio de traducción esté listo
    // Añadir un pequeño delay para asegurar que las traducciones estén completamente cargadas
    setTimeout(() => {
      this.loadColors();
    }, 100);

    // Asegurar que los grupos de complementos estén cargados
    setTimeout(() => {
      if (!this.configurationServices.complements_group_array || this.configurationServices.complements_group_array.length === 0) {
        this.configurationServices.getComplementsGroups();
      }
    }, 200);

    // Agregar listener para cerrar dropdowns cuando se hace clic fuera
    this.addClickOutsideListener();
  }

  ngOnDestroy() {
    // Remover listener cuando se destruye el componente
    this.removeClickOutsideListener();
  }

  private addClickOutsideListener() {
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  private removeClickOutsideListener() {
    document.removeEventListener('click', this.handleClickOutside.bind(this));
  }

  private handleClickOutside(event: any) {
    // Cerrar todos los dropdowns de categorías y complementos
    this.elements.forEach(element => {
      // Verificar si el clic fue fuera del dropdown de categorías
      const categoryDropdown = event.target.closest('.category-search-dropdown');
      const categoryInput = event.target.closest('.categories-wrapper');

      if (!categoryDropdown && !categoryInput) {
        element.categorySearchResults = [];
      }

      // Verificar si el clic fue fuera del dropdown de complementos
      const complementDropdown = event.target.closest('.complement-search-dropdown');
      const complementInput = event.target.closest('.complements-wrapper');

      if (!complementDropdown && !complementInput) {
        element.complementSearchResults = [];
      }
    });
  }

  loadColors() {
    // Asegurar que el servicio de traducción esté configurado con el idioma del restaurante
    this.globals.setTranslate();

    // Obtener colores y ordenarlos alfabéticamente por el nombre ya traducido
    this.colors = this.globals.getColorsElements();

    this.colors.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      return nameA.localeCompare(nameB);
    });

    // Inicializar propiedades de los elementos después de cargar los colores
    // Los colores ya vienen en los datos del endpoint, solo necesitamos inicializar los objetos color
    if (this.elements_working && this.elements_working.length > 0) {
      this.initializeElementProperties(this.elements_working);
      
      // Forzar detección de cambios para actualizar la vista
      this.cdr.detectChanges();
    }
  }

  getTranslatedColorName(colorName: string): string {
    // Los nombres ya vienen traducidos desde getColorsElements()
    return colorName;
  }

  // Función auxiliar para convertir punto en coma en valores de precio
  private convertPriceValue(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    // Convertir a string y normalizar (reemplazar coma por punto para parseFloat)
    const stringValue = String(value).replace(',', '.');

    return parseFloat(stringValue) || 0;
  }

  // Función auxiliar para comparar dos valores de precio correctamente
  // Normaliza ambos valores (strings con coma o punto, o números) y los compara numéricamente
  private comparePriceValues(newValue: any, originalValue: any): boolean {
    // Si el nuevo valor está vacío o undefined, no hay cambio
    if (newValue === null || newValue === undefined || newValue === '') {
      return false;
    }

    // Convertir ambos valores a números para comparar
    const newPriceNum = this.convertPriceValue(newValue);
    const originalPriceNum = this.convertPriceValue(originalValue);

    // Comparar numéricamente (usar Math.abs para manejar errores de punto flotante)
    return Math.abs(newPriceNum - originalPriceNum) > 0.001;
  }

  // Función auxiliar para verificar si las categorías han cambiado
  private hasTagsChanged(currentTags: any, originalTags: any): boolean {
    const current = Array.isArray(currentTags) ? [...currentTags].sort() : [];
    const original = Array.isArray(originalTags) ? [...originalTags].sort() : [];
    
    if (current.length !== original.length) {
      return true;
    }
    
    for (let i = 0; i < current.length; i++) {
      if (current[i] !== original[i]) {
        return true;
      }
    }
    
    return false;
  }

  // Función auxiliar para verificar si los complementos han cambiado
  private hasComplementsChanged(currentComplements: any, originalComplements: any): boolean {
    const current = Array.isArray(currentComplements) ? [...currentComplements].filter(c => c && c.uid) : [];
    const original = Array.isArray(originalComplements) ? [...originalComplements].filter(c => c && c.uid) : [];
    
    if (current.length !== original.length) {
      return true;
    }
    
    const sortedCurrent = [...current].sort((a, b) => a.uid.localeCompare(b.uid));
    const sortedOriginal = [...original].sort((a, b) => a.uid.localeCompare(b.uid));
    
    for (let i = 0; i < sortedCurrent.length; i++) {
      if (sortedCurrent[i].uid !== sortedOriginal[i].uid) {
        return true;
      }
    }
    
    return false;
  }

  // Función para procesar el valor del input en tiempo real
  private processPriceInput(value: any): any {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    // Permitir solo números, puntos y comas
    const cleanValue = String(value).replace(/[^0-9.,]/g, '');

    // Si hay múltiples puntos o comas, mantener solo el primero
    const parts = cleanValue.split(/[.,]/);
    if (parts.length > 2) {
      return parts[0] + ',' + parts.slice(1).join('');
    }

    return cleanValue;
  }

  setNewPrice(value: any, index: number) {
    const element = this.elements[index];
    const processedValue = this.processPriceInput(value);

    // Actualizar el valor mostrado en el input
    if (element.type === 'dish') {
      element.new_price = processedValue;
    } else {
      element.new_pvp = processedValue;
    }
  }

  setNewPrice2(value: any, index: number) {
    const element = this.elements[index];
    const processedValue = this.processPriceInput(value);

    // Actualizar el valor mostrado en el input
    if (element.type === 'dish') {
      element.new_price_half = processedValue;
    } else {
      element.new_pvp2 = processedValue;
    }
  }

  setNewPrice3(value: any, index: number) {
    const element = this.elements[index];
    const processedValue = this.processPriceInput(value);

    // Actualizar el valor mostrado en el input
    if (element.type === 'dish') {
      element.new_price_tapa = processedValue;
    } else {
      element.new_pvp3 = processedValue;
    }
  }

  setNewPriceOnline(value: any, index: number) {
    const element = this.elements[index];
    const processedValue = this.processPriceInput(value);

    // Actualizar el valor mostrado en el input
    if (element.type === 'dish') {
      element.new_price_takeaway = processedValue;
    } else {
      element.new_pvp_takeaway = processedValue;
    }
  }

  setNewName(value: any, i: number) {
    this.elements[i].new_name = value;
  }

  toggleSelectAll() {
    this.selectAll = !this.selectAll;
    this.elements_working.forEach(e => e.selected = this.selectAll);

    // Detectar valores comunes después de cambiar la selección
    this.onSelectElement();

    // Si se seleccionaron todos y hay complementos masivos seleccionados, aplicarlos automáticamente
    if (this.selectAll && this.massiveSelectedComplements && this.massiveSelectedComplements.length > 0) {
      this.applyMassiveSelectedComplements();
    }
  }

  onSelectElement() {
    // Verificar que hay elementos válidos
    if (!this.elements_working || this.elements_working.length === 0) {
      this.clearMassiveControls();
      return;
    }

    // Detectar valores comunes cuando hay elementos seleccionados
    if (this.hasSelected()) {
      // Siempre detectar valores comunes cuando cambia la selección
      const currentSelectedCount = this.elements_working.filter(e => e && e.selected).length;
      this.detectCommonValues();
      this.lastSelectedCount = currentSelectedCount;

      // Si hay complementos masivos seleccionados, aplicarlos a los elementos recién seleccionados
      if (this.massiveSelectedComplements && this.massiveSelectedComplements.length > 0) {
        // Aplicar complementos solo a los elementos que están seleccionados pero no tienen los complementos aplicados
        const selectedElements = this.elements_working.filter(e => e && e.selected);
        selectedElements.forEach(element => {
          if (!element.variations_favourite) {
            element.variations_favourite = [];
          }

          // Verificar si ya tiene todos los complementos masivos aplicados
          const hasAllComplements = this.massiveSelectedComplements.every(complement =>
            element.variations_favourite.some((assigned: any) => assigned.uid === complement.uid)
          );

          if (!hasAllComplements) {
            // Aplicar solo los complementos que faltan
            this.massiveSelectedComplements.forEach(complement => {
              const alreadyAssigned = element.variations_favourite.some((assigned: any) => assigned.uid === complement.uid);
              if (!alreadyAssigned) {
                element.variations_favourite.push({
                  uid: complement.uid,
                  pos_active: complement.pos_active,
                  tk_active: complement.tk_active,
                  name_static: complement.name_static,
                  type_static: complement.type_static
                });
              }
            });
          }
        });
      }
    } else {
      // Limpiar controles si no hay elementos seleccionados
      this.clearMassiveControls();
    }
  }

  hasSelected() {
    return this.elements_working && this.elements_working.length > 0 && this.elements_working.some(e => e && e.selected);
  }

  deleteSelected() {
    const selectedElements = this.elements_working.filter(e => e.selected);

    if (selectedElements.length === 0) {
      return;
    }

    // Crear mensaje de confirmación
    const message = selectedElements.length === 1
      ? this.translate.instant('eliminar-articulo-desc')
      : '¿Seguro que quieres eliminar ' + selectedElements.length + ' ' + this.translate.instant('general-articulos') + '?';

    // Mostrar confirmación
    const alert = this.alertCtrl.create({
      title: this.translate.instant('general-atencion'),
      message: message,
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            // Eliminar de la base de datos
            selectedElements.forEach(element => {
              if (element.type === 'dish') {
                this.articlesServices.afs.collection('dish').doc(element.UID).delete();
                this.globals.GAtrackView('Dish', 'Dish - Delete', this.globals.restaurant.email, 'Delete', 'Delete dish', 'Dish', this.globals.nameLangSelectDish(element));
              } else {
                this.articlesServices.afs.collection('products').doc(element.UID).delete();
                this.globals.GAtrackView('Products', 'Products - Delete', this.globals.restaurant.email, 'Delete', 'Delete product', 'Products', this.globals.nameLangSelectDish(element));
              }
            });

            // Eliminar del array local
            this.elements = this.elements.filter(e => !e.selected);
            this.selectAll = false;

            // Actualizar array original
            selectedElements.forEach(element => {
              const index = this.elements_og.findIndex(x => x.UID === element.UID);
              if (index >= 0) {
                this.elements_og.splice(index, 1);
              }
            });

            // Mostrar mensaje de éxito
            this.globals.launchToast(
              this.translate.instant('general-eliminado-correctamente'),
              3000, 'top'
            );
          }
        }
      ]
    });
    alert.present();
  }

  applyMassiveColor() {
    // Este método se llama cuando se cambia el color masivo desde el header
    // No se debe llamar en cada cambio individual de color
    this.elements_working.forEach(e => {
      if (e.selected) {
        if (this.massiveColor === null) {
          // Quitar color - establecer como null/undefined
          e.color = null;
          e.pos_background_color = null;
          e.pos_border_color = null;
          e.pos_color_name = null;
        } else if (this.massiveColor && typeof this.massiveColor === 'object') {
          // Aplicar color específico
          e.color = this.massiveColor;
          e.pos_background_color = this.massiveColor.pos_background_color;
          e.pos_border_color = this.massiveColor.pos_border_color;
          e.pos_color_name = this.massiveColor.name;
        }
      }
    });
  }

  applyMassiveCategories() {
    if (this.massiveCategories && this.massiveCategories.trim() !== '') {
      const newTags = this.massiveCategories.split(',').map(tag => tag.trim());
      this.elements_working.forEach(e => {
        if (e.selected) {
          if (!e.tags) e.tags = [];
          newTags.forEach(tag => {
            if (!e.tags.includes(tag)) {
              e.tags.push(tag);
            }
          });
        }
      });
    }
  }

  applyMassivePrice() {
    this.elements_working.forEach(e => {
      if (e.selected) {
        if (e.type === 'dish') {
          e.new_price = this.convertPriceValue(this.massivePrice);
        } else {
          e.new_pvp = this.convertPriceValue(this.massivePrice);
        }
      }
    });
  }

  applyMassivePrice2() {
    this.elements_working.forEach(e => {
      if (e.selected) {
        if (e.type === 'dish') {
          e.new_price_half = this.convertPriceValue(this.massivePrice2);
        } else {
          e.new_pvp2 = this.convertPriceValue(this.massivePrice2);
        }
      }
    });
  }

  applyMassivePrice3() {
    this.elements_working.forEach(e => {
      if (e.selected) {
        if (e.type === 'dish') {
          e.new_price_tapa = this.convertPriceValue(this.massivePrice3);
        } else {
          e.new_pvp3 = this.convertPriceValue(this.massivePrice3);
        }
      }
    });
  }

  applyMassivePriceOnline() {
    this.elements_working.forEach(e => {
      if (e.selected) {
        if (e.type === 'dish') {
          e.new_price_takeaway = this.convertPriceValue(this.massivePriceOnline);
        } else {
          e.new_pvp_takeaway = this.convertPriceValue(this.massivePriceOnline);
        }
      }
    });
  }

  applyMassivePosActive() {
    this.elements_working.forEach(e => {
      if (e.selected && this.massivePosActive !== null) {
        e.pos_active = this.massivePosActive;
      }
    });
  }

  applyMassiveFavourite() {
    this.elements_working.forEach(e => {
      if (e.selected && this.massiveFavourite !== null) {
        e.favourite = this.massiveFavourite;
      }
    });
  }

  togglePosActive(element: any) {
    element.pos_active = !element.pos_active;
  }

  toggleFavourite(element: any) {
    element.favourite = !element.favourite;
  }

  save() {
    // Verificar que los complementos masivos se han aplicado correctamente
    if (!this.verifyMassiveComplementsApplied()) {
      this.applyMassiveSelectedComplements();
    }

    // Mostrar loader con mensaje "Guardando"
    const loader = this.loadingCtrl.create({
      content: this.translate.instant('general-guardando') + '...' || 'Guardando...'
    });
    loader.present();

    // Filtrar solo los elementos que realmente tienen cambios (desde elements_working para incluir todos, no solo los filtrados)
    const elementsWithChanges = this.elements_working.filter(element => {
      // Buscar el elemento original
      const originalElement = this.elements_og.find(x => x.UID === element.UID);
      if (!originalElement) {
        return false; // Saltar si no se encuentra el elemento original
      }

      // Verificar cambios en nombre
      if (element.new_name !== undefined && element.new_name.trim() !== '') {
        // Products usan "name" para español, dishes usan "name_es"
        let langField;
        if (element.type === 'dish') {
          langField = 'name_' + this.globals.restaurant.lang;
        } else {
          langField = this.globals.restaurant.lang === 'es' ? 'name' : 'name_' + this.globals.restaurant.lang;
        }
        if (element.new_name.trim() !== originalElement[langField]) {
          return true;
        }
      }

      // Verificar cambios en precios según el tipo de artículo
      if (element.type === 'dish') {
        if (element.new_price !== undefined && this.comparePriceValues(element.new_price, originalElement.price)) return true;
        if (element.new_price_half !== undefined && this.comparePriceValues(element.new_price_half, originalElement.price_half)) return true;
        if (element.new_price_tapa !== undefined && this.comparePriceValues(element.new_price_tapa, originalElement.price_tapa)) return true;
        if (element.new_price_takeaway !== undefined && this.comparePriceValues(element.new_price_takeaway, originalElement.price_takeaway)) return true;
      } else {
        if (element.new_pvp !== undefined && this.comparePriceValues(element.new_pvp, originalElement.pvp)) return true;
        if (element.new_pvp2 !== undefined && this.comparePriceValues(element.new_pvp2, originalElement.pvp2)) return true;
        if (element.new_pvp3 !== undefined && this.comparePriceValues(element.new_pvp3, originalElement.pvp3)) return true;
        if (element.new_pvp_takeaway !== undefined && this.comparePriceValues(element.new_pvp_takeaway, originalElement.pvp_takeaway)) return true;
      }

      // Verificar cambios en color
      // Normalizar strings vacíos a null para comparación consistente
      // Obtener valores de color del elemento actual y original
      const currentColorBg = element.color && typeof element.color === 'object' ? element.color.pos_background_color : null;
      const currentColorBorder = element.color && typeof element.color === 'object' ? element.color.pos_border_color : null;
      const currentColorName = element.color && typeof element.color === 'object' ? element.color.name : null;
      
      // Normalizar strings vacíos del original a null para comparación consistente
      // También normalizar valores como "Sin color" a null
      const originalColorBg = (originalElement.pos_background_color && originalElement.pos_background_color !== '' && originalElement.pos_background_color !== 'Sin color') 
        ? originalElement.pos_background_color 
        : null;
      const originalColorBorder = (originalElement.pos_border_color && originalElement.pos_border_color !== '' && originalElement.pos_border_color !== 'Sin color') 
        ? originalElement.pos_border_color 
        : null;
      // Normalizar cualquier string vacío, "Sin color", o valor equivalente a null
      const originalColorName = (originalElement.pos_color_name && 
                                  originalElement.pos_color_name !== '' && 
                                  originalElement.pos_color_name !== 'Sin color' &&
                                  originalElement.pos_color_name.toLowerCase() !== 'sin color') 
        ? originalElement.pos_color_name 
        : null;
      
      // Comparar valores (null === null, pero null !== "color")
      if (currentColorBg !== originalColorBg || 
          currentColorBorder !== originalColorBorder || 
          currentColorName !== originalColorName) {
        return true;
      }

      // Verificar cambios en categorías (tags) - usar función auxiliar para consistencia
      if (this.hasTagsChanged(element.tags, originalElement.tags)) {
        return true;
      }

      // Verificar cambios en complementos (variations_favourite) - usar función auxiliar para consistencia
      if (this.hasComplementsChanged(element.variations_favourite, originalElement.variations_favourite)) {
        return true;
      }

      // Verificar cambios en pos_active
      if (element.pos_active !== undefined) {
        const originalPosActive = originalElement.pos_active !== undefined ? originalElement.pos_active :
          (originalElement.tpv_active !== undefined ? originalElement.tpv_active : true);

        if (element.pos_active !== originalPosActive) {
          return true;
        }
      }

      // Verificar cambios en favourite
      if (element.favourite !== undefined) {
        const originalFavourite = originalElement.favourite !== undefined ? originalElement.favourite :
          (originalElement.pos_favourite !== undefined ? originalElement.pos_favourite : false);

        if (element.favourite !== originalFavourite) {
          return true;
        }
      }

      // Si llegamos aquí, no hay cambios detectados
      return false; // No hay cambios
    });

    // Si no hay elementos con cambios, salir inmediatamente
    if (elementsWithChanges.length === 0) {
      loader.dismiss();
      this.navCtrl.pop();
      return;
    }

    const updatePromises = [];

    // Procesar solo los elementos con cambios
    for (let element of elementsWithChanges) {
      const originalElement = this.elements_og.find(x => x.UID === element.UID);

      let updateObj: any = {
        'updated_user': this.globals.user_name,
        'updated_at': new Date(),
      };

      // Actualizar precios según el tipo de artículo (solo si han cambiado)
      if (element.type === 'dish') {
        if (element.new_price !== undefined && this.comparePriceValues(element.new_price, originalElement.price)) {
          updateObj['price'] = this.convertPriceValue(element.new_price);
        }
        if (element.new_price_half !== undefined && this.comparePriceValues(element.new_price_half, originalElement.price_half)) {
          updateObj['price_half'] = this.convertPriceValue(element.new_price_half);
        }
        if (element.new_price_tapa !== undefined && this.comparePriceValues(element.new_price_tapa, originalElement.price_tapa)) {
          updateObj['price_tapa'] = this.convertPriceValue(element.new_price_tapa);
        }
        if (element.new_price_takeaway !== undefined && this.comparePriceValues(element.new_price_takeaway, originalElement.price_takeaway)) {
          updateObj['price_takeaway'] = this.convertPriceValue(element.new_price_takeaway);
        }
      } else {
        if (element.new_pvp !== undefined && this.comparePriceValues(element.new_pvp, originalElement.pvp)) {
          updateObj['pvp'] = this.convertPriceValue(element.new_pvp);
        }
        if (element.new_pvp2 !== undefined && this.comparePriceValues(element.new_pvp2, originalElement.pvp2)) {
          updateObj['pvp2'] = this.convertPriceValue(element.new_pvp2);
        }
        if (element.new_pvp3 !== undefined && this.comparePriceValues(element.new_pvp3, originalElement.pvp3)) {
          updateObj['pvp3'] = this.convertPriceValue(element.new_pvp3);
        }
        if (element.new_pvp_takeaway !== undefined && this.comparePriceValues(element.new_pvp_takeaway, originalElement.pvp_takeaway)) {
          updateObj['pvp_takeaway'] = this.convertPriceValue(element.new_pvp_takeaway);
        }
      }

      // Actualizar nombre solo en el idioma del restaurante
      if (element.new_name && element.new_name.trim() !== '') {
        // Products usan "name" para español, dishes usan "name_es"
        let langField;
        if (element.type === 'dish') {
          langField = 'name_' + this.globals.restaurant.lang;
        } else {
          // Para products: español es "name", otros idiomas son "name_xx"
          langField = this.globals.restaurant.lang === 'es' ? 'name' : 'name_' + this.globals.restaurant.lang;
        }
        updateObj[langField] = element.new_name.trim();
      }

      // Actualizar color (incluyendo cuando se quita el color)
      if (element.color && typeof element.color === 'object') {
        // Aplicar color
        updateObj['color'] = element.color;
        updateObj['pos_background_color'] = element.color.pos_background_color;
        updateObj['pos_border_color'] = element.color.pos_border_color;
        updateObj['pos_color_name'] = element.color.name;
      } else if ((originalElement.pos_background_color && originalElement.pos_background_color !== '') && (!element.color || element.color === null)) {
        // Quitar color (el original tenía color pero ahora no)
        updateObj['color'] = null;
        updateObj['pos_background_color'] = null;
        updateObj['pos_border_color'] = null;
        updateObj['pos_color_name'] = null;
      }

      // Actualizar categorías y complementos - normalizar arrays vacíos
      // Solo actualizar si realmente hay diferencia o si queremos asegurar que sea un array vacío en lugar de undefined
      const hasTagsChanged = this.hasTagsChanged(element.tags, originalElement.tags);
      const hasComplementsChanged = this.hasComplementsChanged(element.variations_favourite, originalElement.variations_favourite);
      
      if (hasTagsChanged) {
        // Normalizar a array vacío si es undefined/null
        updateObj['tags'] = Array.isArray(element.tags) ? element.tags : [];
        // Añadir tags nuevos al array global
        if (updateObj['tags'] && updateObj['tags'].length > 0) {
          this.globals.addTagsToGlobal(updateObj['tags']);
        }
      }
      if (hasComplementsChanged) {
        // Normalizar a array vacío si es undefined/null
        updateObj['variations_favourite'] = Array.isArray(element.variations_favourite) ? element.variations_favourite : [];
      }

      // Actualizar POS activo y favorito (SOLO si cambiaron) - previene sobrescribir cambios de otros usuarios
      if (element.pos_active !== undefined) {
        const originalPosActive = originalElement.pos_active !== undefined ? originalElement.pos_active :
          (originalElement.tpv_active !== undefined ? originalElement.tpv_active : true);
        
        if (element.pos_active !== originalPosActive) {
          updateObj['pos_active'] = element.pos_active;
          updateObj['tpv_active'] = element.pos_active;
        }
      }

      if (element.favourite !== undefined) {
        const originalFavourite = originalElement.favourite !== undefined ? originalElement.favourite :
          (originalElement.pos_favourite !== undefined ? originalElement.pos_favourite : false);
        
        if (element.favourite !== originalFavourite) {
          updateObj['favourite'] = element.favourite;
          updateObj['pos_favourite'] = element.favourite;
        }
      }

      // Usar Promise para actualización asíncrona según el tipo
      let updatePromise;
      if (element.type === 'dish') {
        updatePromise = this.articlesServices.afs.collection('dish').doc(element.UID).update(updateObj);
        this.globals.GAtrackView('Dish', 'Dish - Price - Update', this.globals.restaurant.email, 'Create/Update', 'Update price', 'Dish', this.globals.nameLangSelectDish(element));
      } else {
        updatePromise = this.articlesServices.afs.collection('products').doc(element.UID).update(updateObj);
        this.globals.GAtrackView('Products', 'Products - Price - Update', this.globals.restaurant.email, 'Create/Update', 'Update price', 'Products', this.globals.nameLangSelectDish(element));
      }
      updatePromises.push(updatePromise);

      // Actualizar array original inmediatamente (solo para elementos con cambios)
      var index = this.elements_og.findIndex(x => x.UID == element.UID);
      if (index >= 0) {
        // Actualizar precios según el tipo de artículo (solo si han cambiado)
        if (element.type === 'dish') {
          if (element.new_price !== undefined && this.comparePriceValues(element.new_price, originalElement.price)) {
            this.elements_og[index].price = this.convertPriceValue(element.new_price);
          }
          if (element.new_price_half !== undefined && this.comparePriceValues(element.new_price_half, originalElement.price_half)) {
            this.elements_og[index].price_half = this.convertPriceValue(element.new_price_half);
          }
          if (element.new_price_tapa !== undefined && this.comparePriceValues(element.new_price_tapa, originalElement.price_tapa)) {
            this.elements_og[index].price_tapa = this.convertPriceValue(element.new_price_tapa);
          }
          if (element.new_price_takeaway !== undefined && this.comparePriceValues(element.new_price_takeaway, originalElement.price_takeaway)) {
            this.elements_og[index].price_takeaway = this.convertPriceValue(element.new_price_takeaway);
          }
        } else {
          if (element.new_pvp !== undefined && this.comparePriceValues(element.new_pvp, originalElement.pvp)) {
            this.elements_og[index].pvp = this.convertPriceValue(element.new_pvp);
          }
          if (element.new_pvp2 !== undefined && this.comparePriceValues(element.new_pvp2, originalElement.pvp2)) {
            this.elements_og[index].pvp2 = this.convertPriceValue(element.new_pvp2);
          }
          if (element.new_pvp3 !== undefined && this.comparePriceValues(element.new_pvp3, originalElement.pvp3)) {
            this.elements_og[index].pvp3 = this.convertPriceValue(element.new_pvp3);
          }
          if (element.new_pvp_takeaway !== undefined && this.comparePriceValues(element.new_pvp_takeaway, originalElement.pvp_takeaway)) {
            this.elements_og[index].pvp_takeaway = this.convertPriceValue(element.new_pvp_takeaway);
          }
        }

        // Actualizar nombre
        if (element.new_name && element.new_name.trim() !== '') {
          // Products usan "name" para español, dishes usan "name_es"
          let langField;
          if (element.type === 'dish') {
            langField = 'name_' + this.globals.restaurant.lang;
          } else {
            langField = this.globals.restaurant.lang === 'es' ? 'name' : 'name_' + this.globals.restaurant.lang;
          }
          this.elements_og[index][langField] = element.new_name.trim();
        }

        // Actualizar color (incluyendo cuando se quita el color)
        if (element.color && typeof element.color === 'object') {
          this.elements_og[index].color = element.color;
          this.elements_og[index].pos_background_color = element.color.pos_background_color;
          this.elements_og[index].pos_border_color = element.color.pos_border_color;
          this.elements_og[index].pos_color_name = element.color.name;
        } else if ((originalElement.pos_background_color && originalElement.pos_background_color !== '') && (!element.color || element.color === null)) {
          // Quitar color (el original tenía color pero ahora no)
          this.elements_og[index].color = null;
          this.elements_og[index].pos_background_color = null;
          this.elements_og[index].pos_border_color = null;
          this.elements_og[index].pos_color_name = null;
        }

        // Actualizar categorías y complementos (solo si cambiaron)
        if (this.hasTagsChanged(element.tags, originalElement.tags)) {
          this.elements_og[index].tags = Array.isArray(element.tags) ? [...element.tags] : [];
        }
        if (this.hasComplementsChanged(element.variations_favourite, originalElement.variations_favourite)) {
          this.elements_og[index].variations_favourite = Array.isArray(element.variations_favourite) ? [...element.variations_favourite] : [];
        }

        // Actualizar POS activo y favorito
        if (element.pos_active !== undefined) {
          this.elements_og[index].pos_active = element.pos_active;
          this.elements_og[index].tpv_active = element.pos_active;
        }
        if (element.favourite !== undefined) {
          this.elements_og[index].favourite = element.favourite;
          this.elements_og[index].pos_favourite = element.favourite;
        }
      }
    }

    // Ejecutar todas las actualizaciones en paralelo
    Promise.all(updatePromises).then(() => {
      // Actualizar inmediatamente la caché local del servicio de artículos
      this.updateLocalCache();

      this.staticsServices.changeStateStaticWait(true);
      loader.dismiss();

      // Mostrar mensaje de éxito con el número de artículos actualizados
      let toast = this.toastCtrl.create({
        message: `${elementsWithChanges.length} ${this.translate.instant('general-articulos')} ${this.translate.instant('general-actualizados')}` || `${elementsWithChanges.length} artículos actualizados`,
        duration: 3000,
        position: 'bottom'
      });
      toast.present();

      this.navCtrl.pop();
    }).catch(error => {
      loader.dismiss();
      this.alertCtrl.create({
        title: this.translate.instant('general-error'),
        message: this.translate.instant('general-error-guardar-cambios'),
        buttons: ['OK']
      }).present();
    });
  }

  updateLocalCache() {
    // Actualizar inmediatamente la caché local del servicio de artículos (solo elementos con cambios)
    this.elements_working.forEach(element => {
      // Verificar si el elemento tiene cambios antes de actualizar la caché
      const originalElement = this.elements_og.find(x => x.UID === element.UID);
      if (!originalElement) return;

      let hasChanges = false;

      // Verificar cambios en precios (usando comparePriceValues para consistencia)
      if (element.type === 'dish') {
        if (element.new_price !== undefined && this.comparePriceValues(element.new_price, originalElement.price)) hasChanges = true;
        if (element.new_price_half !== undefined && this.comparePriceValues(element.new_price_half, originalElement.price_half)) hasChanges = true;
        if (element.new_price_tapa !== undefined && this.comparePriceValues(element.new_price_tapa, originalElement.price_tapa)) hasChanges = true;
        if (element.new_price_takeaway !== undefined && this.comparePriceValues(element.new_price_takeaway, originalElement.price_takeaway)) hasChanges = true;
      } else {
        if (element.new_pvp !== undefined && this.comparePriceValues(element.new_pvp, originalElement.pvp)) hasChanges = true;
        if (element.new_pvp2 !== undefined && this.comparePriceValues(element.new_pvp2, originalElement.pvp2)) hasChanges = true;
        if (element.new_pvp3 !== undefined && this.comparePriceValues(element.new_pvp3, originalElement.pvp3)) hasChanges = true;
        if (element.new_pvp_takeaway !== undefined && this.comparePriceValues(element.new_pvp_takeaway, originalElement.pvp_takeaway)) hasChanges = true;
      }

      // Verificar otros cambios  
      if (element.new_name !== undefined && element.new_name.trim() !== '') {
        // Products usan "name" para español, dishes usan "name_es"
        let langField;
        if (element.type === 'dish') {
          langField = 'name_' + this.globals.restaurant.lang;
        } else {
          langField = this.globals.restaurant.lang === 'es' ? 'name' : 'name_' + this.globals.restaurant.lang;
        }
        if (element.new_name.trim() !== originalElement[langField]) hasChanges = true;
      }
      // Verificar cambios en color (usando la misma lógica que en save)
      // Normalizar strings vacíos a null para comparación consistente
      const currentColorBg = element.color && typeof element.color === 'object' ? element.color.pos_background_color : null;
      const currentColorBorder = element.color && typeof element.color === 'object' ? element.color.pos_border_color : null;
      const currentColorName = element.color && typeof element.color === 'object' ? element.color.name : null;
      
      // Normalizar strings vacíos del original a null para comparación consistente
      const originalColorBg = (originalElement.pos_background_color && originalElement.pos_background_color !== '') 
        ? originalElement.pos_background_color 
        : null;
      const originalColorBorder = (originalElement.pos_border_color && originalElement.pos_border_color !== '') 
        ? originalElement.pos_border_color 
        : null;
      const originalColorName = (originalElement.pos_color_name && originalElement.pos_color_name !== '') 
        ? originalElement.pos_color_name 
        : null;
      
      if (currentColorBg !== originalColorBg || 
          currentColorBorder !== originalColorBorder || 
          currentColorName !== originalColorName) {
        hasChanges = true;
      }
      
      // Verificar cambios en categorías y complementos (usando funciones auxiliares para consistencia)
      if (this.hasTagsChanged(element.tags, originalElement.tags)) hasChanges = true;
      if (this.hasComplementsChanged(element.variations_favourite, originalElement.variations_favourite)) hasChanges = true;
      if (element.pos_active !== undefined && element.pos_active !== (originalElement.pos_active !== undefined ? originalElement.pos_active : originalElement.tpv_active)) hasChanges = true;
      if (element.favourite !== undefined && element.favourite !== (originalElement.favourite !== undefined ? originalElement.favourite : originalElement.pos_favourite)) hasChanges = true;

      // Solo actualizar si hay cambios
      if (!hasChanges) return;

      const index = this.articlesServices.list_dishes_products_array.findIndex(x => x.UID == element.UID);
      if (index >= 0) {
        // Actualizar precios según el tipo de artículo (solo si han cambiado, usando comparePriceValues)
        if (element.type === 'dish') {
          if (element.new_price !== undefined && this.comparePriceValues(element.new_price, originalElement.price)) {
            this.articlesServices.list_dishes_products_array[index].price = this.convertPriceValue(element.new_price);
          }
          if (element.new_price_half !== undefined && this.comparePriceValues(element.new_price_half, originalElement.price_half)) {
            this.articlesServices.list_dishes_products_array[index].price_half = this.convertPriceValue(element.new_price_half);
          }
          if (element.new_price_tapa !== undefined && this.comparePriceValues(element.new_price_tapa, originalElement.price_tapa)) {
            this.articlesServices.list_dishes_products_array[index].price_tapa = this.convertPriceValue(element.new_price_tapa);
          }
          if (element.new_price_takeaway !== undefined && this.comparePriceValues(element.new_price_takeaway, originalElement.price_takeaway)) {
            this.articlesServices.list_dishes_products_array[index].price_takeaway = this.convertPriceValue(element.new_price_takeaway);
          }
        } else {
          if (element.new_pvp !== undefined && this.comparePriceValues(element.new_pvp, originalElement.pvp)) {
            this.articlesServices.list_dishes_products_array[index].pvp = this.convertPriceValue(element.new_pvp);
          }
          if (element.new_pvp2 !== undefined && this.comparePriceValues(element.new_pvp2, originalElement.pvp2)) {
            this.articlesServices.list_dishes_products_array[index].pvp2 = this.convertPriceValue(element.new_pvp2);
          }
          if (element.new_pvp3 !== undefined && this.comparePriceValues(element.new_pvp3, originalElement.pvp3)) {
            this.articlesServices.list_dishes_products_array[index].pvp3 = this.convertPriceValue(element.new_pvp3);
          }
          if (element.new_pvp_takeaway !== undefined && this.comparePriceValues(element.new_pvp_takeaway, originalElement.pvp_takeaway)) {
            this.articlesServices.list_dishes_products_array[index].pvp_takeaway = this.convertPriceValue(element.new_pvp_takeaway);
          }
        }

        // Actualizar nombre solo en el idioma del restaurante
        if (element.new_name && element.new_name.trim() !== '') {
          // Products usan "name" para español, dishes usan "name_es"
          let langField;
          if (element.type === 'dish') {
            langField = 'name_' + this.globals.restaurant.lang;
          } else {
            langField = this.globals.restaurant.lang === 'es' ? 'name' : 'name_' + this.globals.restaurant.lang;
          }
          this.articlesServices.list_dishes_products_array[index][langField] = element.new_name.trim();
        }

        // Actualizar color (incluyendo cuando se quita el color)
        if (element.color && typeof element.color === 'object') {
          this.articlesServices.list_dishes_products_array[index].color = element.color;
          this.articlesServices.list_dishes_products_array[index].pos_background_color = element.color.pos_background_color;
          this.articlesServices.list_dishes_products_array[index].pos_border_color = element.color.pos_border_color;
          this.articlesServices.list_dishes_products_array[index].pos_color_name = element.color.name;
        } else if ((originalElement.pos_background_color && originalElement.pos_background_color !== '') && (!element.color || element.color === null)) {
          // Quitar color (el original tenía color pero ahora no)
          this.articlesServices.list_dishes_products_array[index].color = null;
          this.articlesServices.list_dishes_products_array[index].pos_background_color = null;
          this.articlesServices.list_dishes_products_array[index].pos_border_color = null;
          this.articlesServices.list_dishes_products_array[index].pos_color_name = null;
        }

        // Actualizar categorías (solo si cambiaron)
        if (this.hasTagsChanged(element.tags, originalElement.tags)) {
          this.articlesServices.list_dishes_products_array[index].tags = Array.isArray(element.tags) ? [...element.tags] : [];
        }

        // Actualizar complementos (solo si cambiaron)
        if (this.hasComplementsChanged(element.variations_favourite, originalElement.variations_favourite)) {
          this.articlesServices.list_dishes_products_array[index].variations_favourite = Array.isArray(element.variations_favourite) ? [...element.variations_favourite] : [];
        }

        // Actualizar POS activo y favorito
        if (element.pos_active !== undefined) {
          this.articlesServices.list_dishes_products_array[index].pos_active = element.pos_active;
          this.articlesServices.list_dishes_products_array[index].tpv_active = element.pos_active;
        }

        if (element.favourite !== undefined) {
          this.articlesServices.list_dishes_products_array[index].favourite = element.favourite;
          this.articlesServices.list_dishes_products_array[index].pos_favourite = element.favourite;
        }
      }
    });

    // Forzar la actualización de la vista
    this.articlesServices.list_dishes_products_array = [...this.articlesServices.list_dishes_products_array];
  }

  profitFoodCost(price: number, foodcost: number) {
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
    if (price != 0 && foodcost != 0) {
      return (100 - this.globals.regla3(price, foodcost)).toFixed(0);
    } else {
      return 0;
    }
  }

  getColor(value: number): string {
    if (value > 66) {
      return '#00b19d';
    } else if (value < 33) {
      return '#ef5350';
    } else {
      return '#fa0';
    }
  }

  // Array de trabajo que mantiene todos los elementos con sus modificaciones
  elements_working = [];

  articles_searchbar_text: string = '';
  search(value: string) {
    if (value && value.trim() !== '') {
      const searchValue = value.toLowerCase().trim();

      // Filtrar desde elements_working (que mantiene las modificaciones del usuario)
      this.elements = this.elements_working.filter(element => {
        // Buscar en el nombre del artículo usando la función de idioma apropiada
        let nameMatch = false;

        try {
          if (element.type === 'dish') {
            const dishName = this.globals.nameLangSelectDish(element);
            if (dishName && dishName.trim() !== '') {
              nameMatch = dishName.toLowerCase().includes(searchValue);
            }
          } else if (element.type === 'product') {
            const productName = this.globals.nameLangSelectProduct(element);
            if (productName && productName.trim() !== '') {
              nameMatch = productName.toLowerCase().includes(searchValue);
            }
          }
        } catch (error) {
        }

        // Si no se encontró coincidencia en el nombre, buscar en todos los campos de nombre disponibles
        if (!nameMatch) {
          const nameFields = ['name', 'name_es', 'name_ca', 'name_en', 'name_de', 'name_fr', 'name_it'];
          for (const field of nameFields) {
            if (element[field] && element[field].toString().toLowerCase().includes(searchValue)) {
              nameMatch = true;
              break;
            }
          }
        }

        // Buscar en las categorías
        let categoryMatch = false;
        if (searchValue === 'sin categoria' || searchValue === 'sin categoría') {
          // Búsqueda específica para artículos sin categorías
          categoryMatch = !element.tags || element.tags.length === 0;
        } else if (element.tags && element.tags.length > 0) {
          // Búsqueda en categorías existentes
          categoryMatch = element.tags.some(tag =>
            tag && tag.toString().toLowerCase().includes(searchValue)
          );
        }

        // Mostrar si coincide con nombre o categoría
        return nameMatch || categoryMatch;
      });

      // Asegurar que los elementos filtrados mantengan sus propiedades de color y estado
      this.initializeElementProperties(this.elements);
    } else {
      // Si no hay valor de búsqueda, mostrar todos los elementos desde el array de trabajo
      this.elements = this.elements_working;
      // Asegurar que los elementos restaurados mantengan sus propiedades
      this.initializeElementProperties(this.elements);
    }
  }

  // Función auxiliar para inicializar propiedades de elementos
  private initializeElementProperties(elements: any[]) {
    // Si los colores aún no están cargados, no hacer nada (se llamará después en loadColors)
    if (!this.colors || this.colors.length === 0) {
      return;
    }

    elements.forEach((element) => {
      // Obtener el valor de color de fondo del elemento (ya sea del objeto color o de la propiedad directa)
      // Normalizar valores vacíos: convertir strings vacíos a null
      const normalizedPosBgColor = element.pos_background_color && element.pos_background_color !== '' 
        ? element.pos_background_color 
        : null;
      
      const elementBgColor = element.color && typeof element.color === 'object' 
        ? element.color.pos_background_color 
        : normalizedPosBgColor;

      // Si hay un color de fondo, buscar el objeto color correspondiente en el array
      if (elementBgColor) {
        const colorObj = this.colors.find(c => c.pos_background_color === elementBgColor);
        if (colorObj) {
          // Siempre usar el objeto del array colors para asegurar que coincida con el select
          element.color = colorObj;
          element.pos_background_color = colorObj.pos_background_color;
          element.pos_border_color = colorObj.pos_border_color;
        } else {
          // Si no se encuentra en el array, el color puede haber sido eliminado
          // Mantener las propiedades pero sin objeto color (se mostrará como sin color en el select)
          element.color = null;
        }
      } else if (element.color && typeof element.color === 'string') {
        // Si el color es un string, intentar convertirlo al formato de objeto
        const colorObj = this.colors.find(c => c.pos_background_color === element.color);
        if (colorObj) {
          element.color = colorObj;
          element.pos_background_color = colorObj.pos_background_color;
          element.pos_border_color = colorObj.pos_border_color;
        } else {
          element.color = null;
        }
      } else {
        // No hay color
        element.color = null;
      }

      // Asegurar que las propiedades de estado estén inicializadas
      if (element.pos_active === undefined) {
        element.pos_active = element.tpv_active !== undefined ? element.tpv_active : true;
      }

      if (element.favourite === undefined) {
        element.favourite = element.pos_favourite !== undefined ? element.pos_favourite : false;
      }

      // Asegurar que otras propiedades importantes estén inicializadas
      if (element.selected === undefined) {
        element.selected = false;
      }

      // Asegurar que las categorías estén inicializadas como array
      if (element.tags === undefined) {
        element.tags = [];
      } else if (!Array.isArray(element.tags)) {
        element.tags = [];
      }

      // Asegurar que los complementos estén inicializados como array
      if (element.variations_favourite === undefined) {
        element.variations_favourite = [];
      } else if (!Array.isArray(element.variations_favourite)) {
        element.variations_favourite = [];
      }

      // Crear copias profundas de arrays para evitar referencias compartidas
      element.tags = [...element.tags];
      element.variations_favourite = [...element.variations_favourite];
    });
  }

  addTag(element: any) {
    if (element.newTag && element.newTag.trim() !== '') {
      if (!element.tags) {
        element.tags = [];
      }
      // Evitar duplicados
      if (!element.tags.includes(element.newTag.trim())) {
        element.tags.push(element.newTag.trim());
      }
      element.newTag = ''; // Limpiar input
      element.categorySearchResults = []; // Limpiar resultados de búsqueda
    }
  }

  searchCategories(element: any, searchValue: string) {
    // Obtener todas las categorías únicas de todos los artículos
    const allCategories = new Set<string>();
    this.elements_working.forEach(item => {
      if (item.tags && item.tags.length > 0) {
        item.tags.forEach((tag: string) => allCategories.add(tag));
      }
    });

    const categoriesList = Array.from(allCategories).sort();

    if (!searchValue || searchValue.trim() === '') {
      // Si no hay texto de búsqueda, mostrar todas las categorías disponibles
      element.categorySearchResults = categoriesList.filter(category => {
        return !element.tags || element.tags.indexOf(category) === -1;
      });
      return;
    }

    // Filtrar categorías que coincidan con la búsqueda
    const filteredCategories = categoriesList.filter(category =>
      category.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
    );

    // Excluir categorías que ya están asignadas al elemento
    element.categorySearchResults = filteredCategories.filter(category => {
      return !element.tags || element.tags.indexOf(category) === -1;
    });

    // Limitar a 2 resultados para el dropdown
    element.categorySearchResults = element.categorySearchResults.slice(0, 2);
  }

  addTagFromList(element: any, category: string) {
    if (!element.tags) {
      element.tags = [];
    }
    // Evitar duplicados
    if (!element.tags.includes(category)) {
      element.tags.push(category);
    }
    // Limpiar búsqueda y cerrar dropdown
    element.newTag = '';
    element.categorySearchResults = [];
  }

  removeTag(element: any, tag: string) {
    if (element.tags) {
      const index = element.tags.indexOf(tag);
      if (index > -1) {
        element.tags.splice(index, 1);
      }
    }
  }

  searchComplements(element: any, searchValue: string) {
    // Si no hay grupos de complementos cargados, intentar cargarlos
    if (!this.configurationServices.complements_group_array || this.configurationServices.complements_group_array.length === 0) {
      this.configurationServices.getComplementsGroups();
      element.complementSearchResults = [];
      return;
    }

    if (!searchValue || searchValue.trim() === '') {
      // Si no hay texto de búsqueda, mostrar todos los grupos disponibles
      const availableGroups = this.configurationServices.complements_group_array.filter((group: any) => {
        return !element.variations_favourite ||
          !element.variations_favourite.some((assigned: any) => assigned.uid === group.UID);
      });

      // Crear objetos con las propiedades necesarias para el dropdown - mostrar todos los grupos
      element.complementSearchResults = availableGroups.map((group: any) => ({
        ...group,
        name_static: this.globals.nameNotEsLang(group),
        description_static: group.description || group.desc || ''
      }));
      return;
    }

    // Filtrar grupos de complementos que coincidan con la búsqueda
    const filteredGroups = this.configurationServices.complements_group_array.filter((group: any) => {
      const groupName = this.globals.nameNotEsLang(group).toLowerCase();
      return groupName.indexOf(searchValue.toLowerCase()) !== -1;
    });

    // Excluir grupos que ya están asignados al elemento
    const availableGroups = filteredGroups.filter((group: any) => {
      return !element.variations_favourite ||
        !element.variations_favourite.some((assigned: any) => assigned.uid === group.UID);
    });

    // Crear objetos con las propiedades necesarias para el dropdown - limitar a 2 solo en búsqueda
    element.complementSearchResults = availableGroups.slice(0, 2).map((group: any) => ({
      ...group,
      name_static: this.globals.nameNotEsLang(group),
      description_static: group.description || group.desc || ''
    }));
  }

  selectComplementGroup(element: any, group: any) {
    // Verificar si el grupo ya está asignado
    if (!element.variations_favourite) {
      element.variations_favourite = [];
    }

    const alreadyAssigned = element.variations_favourite.some((assigned: any) => assigned.uid === group.UID);
    if (!alreadyAssigned) {
      // Añadir el grupo de complementos
      element.variations_favourite.push({
        uid: group.UID,
        pos_active: true,
        tk_active: false,
        name_static: group.name_static || this.globals.nameNotEsLang(group),
        type_static: 'group'
      });
    }

    // Limpiar búsqueda y cerrar dropdown
    element.newComplementSearch = '';
    element.complementSearchResults = [];
  }

  addComplementFromSearch(element: any) {
    if (!element.newComplementSearch || element.newComplementSearch.trim() === '') {
      return;
    }

    // Buscar el primer grupo que coincida exactamente
    const exactMatch = this.configurationServices.complements_group_array.find((group: any) => {
      const groupName = this.globals.nameNotEsLang(group).toLowerCase();
      return groupName === element.newComplementSearch.toLowerCase();
    });

    if (exactMatch) {
      this.selectComplementGroup(element, exactMatch);
    } else if (element.complementSearchResults && element.complementSearchResults.length > 0) {
      // Si no hay coincidencia exacta, seleccionar el primer resultado
      this.selectComplementGroup(element, element.complementSearchResults[0]);
    }
  }

  setBackgroundColor(color: any) {
    return {
      'background-color': color.pos_background_color,
      'border': '1px solid ' + color.pos_border_color
    }
  }

  removeComplement(element: any, complement: any) {
    if (element.variations_favourite) {
      const index = element.variations_favourite.findIndex((c: any) => c.uid === complement.uid);
      if (index > -1) {
        element.variations_favourite.splice(index, 1);
      }
    }
  }

  // Nuevo método para aplicar todos los cambios masivos de una vez
  applyMassiveChanges() {
    // Aplicar precios
    if (this.massivePrice !== null && this.massivePrice !== '') {
      this.applyMassivePrice();
    }
    if (this.massivePrice2 !== null && this.massivePrice2 !== '') {
      this.applyMassivePrice2();
    }
    if (this.massivePrice3 !== null && this.massivePrice3 !== '') {
      this.applyMassivePrice3();
    }
    if (this.massivePriceOnline !== null && this.massivePriceOnline !== '') {
      this.applyMassivePriceOnline();
    }

    // Aplicar color (permitir cualquier color válido, incluyendo "sin color")
    if (this.massiveColor !== null && this.massiveColor !== undefined) {
      this.applyMassiveColor();
    }

    // Aplicar estado activo
    if (this.massivePosActive !== null) {
      this.applyMassivePosActive();
    }

    // Aplicar favorito
    if (this.massiveFavourite !== null) {
      this.applyMassiveFavourite();
    }

    // Aplicar categorías seleccionadas (siempre aplicar para manejar eliminaciones)
    this.applyMassiveSelectedCategories();

    // Aplicar complementos (siempre aplicar para manejar eliminaciones)
    this.applyMassiveSelectedComplements();

    // Mostrar mensaje de confirmación
    let toast = this.toastCtrl.create({
      message: this.translate.instant('articles-cambios-aplicados-correctamente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

  // Método para verificar que los complementos masivos se han aplicado correctamente
  verifyMassiveComplementsApplied() {
    if (!this.massiveSelectedComplements || this.massiveSelectedComplements.length === 0) {
      return true; // No hay complementos masivos para verificar
    }

    const selectedElements = this.elements_working.filter(e => e.selected);
    let allApplied = true;

    selectedElements.forEach(element => {
      if (!element.variations_favourite) {
        element.variations_favourite = [];
      }

      // Verificar si todos los complementos masivos están aplicados
      const missingComplements = this.massiveSelectedComplements.filter(complement =>
        !element.variations_favourite.some((assigned: any) => assigned.uid === complement.uid)
      );

      if (missingComplements.length > 0) {
        allApplied = false;
      }
    });

    return allApplied;
  }

  // Método para verificar si hay cambios masivos pendientes
  hasAnyMassiveChanges(): boolean {
    return (this.massivePrice !== null && this.massivePrice !== '') ||
      (this.massivePrice2 !== null && this.massivePrice2 !== '') ||
      (this.massivePrice3 !== null && this.massivePrice3 !== '') ||
      (this.massivePriceOnline !== null && this.massivePriceOnline !== '') ||
      (this.massiveColor !== null && this.massiveColor !== undefined) ||
      this.massivePosActive !== null ||
      this.massiveFavourite !== null ||
      this.hasCommonValuesDetected ||
      (this.massiveSelectedCategories && this.massiveSelectedCategories.length > 0) ||
      (this.massiveSelectedComplements && this.massiveSelectedComplements.length > 0) ||
      (this.massiveRemovedCategories && this.massiveRemovedCategories.length > 0) ||
      (this.massiveRemovedComplements && this.massiveRemovedComplements.length > 0);
  }

  // Método para obtener el número de elementos seleccionados
  getSelectedCount(): number {
    return this.elements_working.filter(e => e.selected).length;
  }

  // Método para detectar valores comunes entre artículos seleccionados
  detectCommonValues() {
    // Verificar que hay elementos disponibles
    if (!this.elements_working || this.elements_working.length === 0) {
      this.clearMassiveControls();
      this.hasCommonValuesDetected = false;
      return;
    }

    const selectedElements = this.elements_working.filter(e => e && e.selected);

    if (selectedElements.length === 0) {
      this.clearMassiveControls();
      this.hasCommonValuesDetected = false;
      return;
    }

    // Si solo hay un elemento seleccionado, mostrar todos sus valores
    if (selectedElements.length === 1) {
      this.detectSingleElementValues(selectedElements[0]);
    } else {
      // Si hay múltiples elementos seleccionados, detectar valores comunes
      this.detectMultipleElementsCommonValues(selectedElements);
    }

    // Marcar que se han detectado valores comunes
    this.hasCommonValuesDetected = true;
    this.lastSelectedCount = selectedElements.length;
  }

  // Detectar todos los valores de un elemento individual
  private detectSingleElementValues(element: any) {
    // Color
    if (element.color && typeof element.color === 'object' && element.color.pos_background_color) {
      this.massiveColor = element.color;
    } else if (element.pos_background_color) {
      // Si no tiene objeto color pero sí tiene pos_background_color
      const colorObj = this.colors.find(c => c.pos_background_color === element.pos_background_color);
      if (colorObj) {
        this.massiveColor = colorObj;
      } else {
        this.massiveColor = {
          pos_background_color: element.pos_background_color,
          pos_border_color: element.pos_border_color || element.pos_background_color,
          name: element.pos_color_name || element.pos_background_color
        };
      }
    } else {
      this.massiveColor = null;
    }

    // Categorías
    if (this.manualChangesMade) {
      // Preservar las categorías que el usuario ha añadido manualmente
      const manuallyAddedCategories = this.massiveSelectedCategories.filter(cat =>
        !element.tags || element.tags.indexOf(cat) === -1
      );
      this.massiveSelectedCategories = [
        ...(element.tags && element.tags.length > 0 ? element.tags : []),
        ...manuallyAddedCategories
      ];
    } else {
      this.massiveSelectedCategories = element.tags && element.tags.length > 0 ? [...element.tags] : [];
    }

    // Complementos
    if (this.manualChangesMade) {
      // Preservar los complementos que el usuario ha añadido manualmente
      const manuallyAddedComplements = this.massiveSelectedComplements.filter(complement =>
        !element.variations_favourite || !element.variations_favourite.some((c: any) => c.uid === complement.uid)
      );
      this.massiveSelectedComplements = [
        ...(element.variations_favourite && element.variations_favourite.length > 0 ? element.variations_favourite : []),
        ...manuallyAddedComplements
      ];
    } else {
      this.massiveSelectedComplements = element.variations_favourite && element.variations_favourite.length > 0 ?
        [...element.variations_favourite] : [];
    }

    // Estados
    this.massivePosActive = element.pos_active !== undefined ? element.pos_active :
      (element.tpv_active !== undefined ? element.tpv_active : true);
    this.massiveFavourite = element.favourite !== undefined ? element.favourite :
      (element.pos_favourite !== undefined ? element.pos_favourite : false);

    // Precios según el tipo de artículo
    if (element.type === 'dish') {
      this.massivePrice = element.price;
      this.massivePrice2 = element.price_half;
      this.massivePrice3 = element.price_tapa;
      this.massivePriceOnline = element.price_takeaway;
    } else {
      this.massivePrice = element.pvp;
      this.massivePrice2 = element.pvp2;
      this.massivePrice3 = element.pvp3;
      this.massivePriceOnline = element.pvp_takeaway;
    }
  }

  // Detectar valores comunes entre múltiples elementos
  private detectMultipleElementsCommonValues(selectedElements: any[]) {
    // Detectar colores comunes
    this.detectCommonColors(selectedElements);

    // Detectar categorías comunes
    this.detectCommonCategories(selectedElements);

    // Detectar complementos comunes
    this.detectCommonComplements(selectedElements);

    // Detectar estados comunes
    this.detectCommonStates(selectedElements);

    // Detectar precios comunes
    this.detectCommonPrices(selectedElements);
  }

  // Detectar colores comunes
  private detectCommonColors(selectedElements: any[]) {
    // Extraer los colores de fondo de todos los elementos seleccionados
    const colorValues = selectedElements.map(el => {
      if (el && el.color && typeof el.color === 'object' && el.color.pos_background_color) {
        return el.color.pos_background_color;
      } else if (el && el.pos_background_color) {
        // Si no tiene objeto color pero sí tiene pos_background_color
        return el.pos_background_color;
      } else {
        // Sin color (null, undefined, o string vacío)
        return null;
      }
    });

    // Obtener colores únicos (excluyendo null/undefined)
    const uniqueColors = colorValues.filter((color, index) =>
      color !== null && color !== undefined && color !== '' && colorValues.indexOf(color) === index
    );

    // Contar elementos con color vs sin color
    const elementsWithoutColor = colorValues.filter(color => color === null || color === undefined || color === '').length;

    if (uniqueColors.length === 1 && elementsWithoutColor === 0) {
      // TODOS los elementos tienen el mismo color
      const commonColor = this.colors.find(c => c.pos_background_color === uniqueColors[0]);
      if (commonColor) {
        this.massiveColor = commonColor;
      } else {
        // Si no se encuentra en la lista de colores, crear un objeto color básico
        this.massiveColor = {
          pos_background_color: uniqueColors[0],
          pos_border_color: uniqueColors[0],
          name: uniqueColors[0]
        };
      }
    } else {
      // Diferentes colores o algunos sin color
      this.massiveColor = null;
    }
  }

  // Detectar categorías comunes
  private detectCommonCategories(selectedElements: any[]) {
    // Si no hay elementos seleccionados, no hay categorías comunes
    if (!selectedElements || selectedElements.length === 0) {
      this.massiveSelectedCategories = [];
      return;
    }

    // Obtener todas las categorías únicas de todos los elementos seleccionados
    const allCategories: string[] = [];
    selectedElements.forEach(element => {
      if (element && element.tags && Array.isArray(element.tags) && element.tags.length > 0) {
        element.tags.forEach((tag: string) => {
          if (tag && tag.trim() !== '' && allCategories.indexOf(tag.trim()) === -1) {
            allCategories.push(tag.trim());
          }
        });
      }
    });

    // Si no hay categorías en ningún elemento, no hay categorías comunes
    if (allCategories.length === 0) {
      this.massiveSelectedCategories = [];
      return;
    }

    // Verificar cuáles categorías están presentes en TODOS los elementos seleccionados
    const commonCategories: string[] = [];
    allCategories.forEach(category => {
      const isInAll = selectedElements.every(element =>
        element && element.tags && Array.isArray(element.tags) &&
        element.tags.some((tag: string) => tag && tag.trim() === category)
      );
      if (isInAll) {
        commonCategories.push(category);
      }
    });

    // Siempre actualizar las categorías comunes, pero preservar las añadidas manualmente
    if (this.manualChangesMade) {
      // Preservar las categorías que el usuario ha añadido manualmente
      const manuallyAddedCategories = this.massiveSelectedCategories.filter(cat =>
        commonCategories.indexOf(cat) === -1
      );
      this.massiveSelectedCategories = [...commonCategories, ...manuallyAddedCategories];
    } else {
      // Si no se han hecho cambios manuales, usar solo las categorías comunes
      this.massiveSelectedCategories = commonCategories;
    }
  }

  // Detectar complementos comunes
  private detectCommonComplements(selectedElements: any[]) {
    // Si no hay elementos seleccionados, no hay complementos comunes
    if (!selectedElements || selectedElements.length === 0) {
      this.massiveSelectedComplements = [];
      return;
    }

    // Obtener todos los complementos únicos de todos los elementos seleccionados
    const allComplements: any[] = [];
    const complementMap: { [key: string]: any } = {};

    selectedElements.forEach(element => {
      if (element && element.variations_favourite && Array.isArray(element.variations_favourite) && element.variations_favourite.length > 0) {
        element.variations_favourite.forEach((complement: any) => {
          if (complement && complement.uid && !complementMap[complement.uid]) {
            complementMap[complement.uid] = complement;
            allComplements.push(complement);
          }
        });
      }
    });

    // Si no hay complementos en ningún elemento, no hay complementos comunes
    if (allComplements.length === 0) {
      this.massiveSelectedComplements = [];
      return;
    }

    // Verificar cuáles complementos están presentes en TODOS los elementos seleccionados
    const commonComplements: any[] = [];
    allComplements.forEach(complement => {
      const isInAll = selectedElements.every(element =>
        element && element.variations_favourite && Array.isArray(element.variations_favourite) &&
        element.variations_favourite.some((c: any) => c && c.uid === complement.uid)
      );
      if (isInAll) {
        commonComplements.push(complement);
      }
    });

    // Siempre actualizar los complementos comunes, pero preservar los añadidos manualmente
    if (this.manualChangesMade) {
      // Preservar los complementos que el usuario ha añadido manualmente
      const manuallyAddedComplements = this.massiveSelectedComplements.filter(complement =>
        !commonComplements.some(commonComplement => commonComplement.uid === complement.uid)
      );
      this.massiveSelectedComplements = [...commonComplements, ...manuallyAddedComplements];
    } else {
      // Si no se han hecho cambios manuales, usar solo los complementos comunes
      this.massiveSelectedComplements = commonComplements;
    }
  }

  // Detectar estados comunes
  private detectCommonStates(selectedElements: any[]) {
    // Si no hay elementos seleccionados, no hay estados comunes
    if (!selectedElements || selectedElements.length === 0) {
      this.massivePosActive = null;
      this.massiveFavourite = null;
      return;
    }

    // Detectar estado POS activo común
    const posActiveStates = selectedElements.map(el => {
      if (el && el.pos_active !== undefined) {
        return el.pos_active;
      } else if (el && el.tpv_active !== undefined) {
        return el.tpv_active;
      } else {
        return true; // Valor por defecto
      }
    });

    const uniquePosActive = posActiveStates.filter((state, index) => posActiveStates.indexOf(state) === index);

    if (uniquePosActive.length === 1) {
      this.massivePosActive = uniquePosActive[0];
    } else {
      this.massivePosActive = null;
    }

    // Detectar estado favorito común
    const favouriteStates = selectedElements.map(el => {
      if (el && el.favourite !== undefined) {
        return el.favourite;
      } else if (el && el.pos_favourite !== undefined) {
        return el.pos_favourite;
      } else {
        return false; // Valor por defecto
      }
    });

    const uniqueFavourite = favouriteStates.filter((state, index) => favouriteStates.indexOf(state) === index);

    if (uniqueFavourite.length === 1) {
      this.massiveFavourite = uniqueFavourite[0];
    } else {
      this.massiveFavourite = null;
    }
  }

  // Detectar precios comunes
  private detectCommonPrices(selectedElements: any[]) {
    // Verificar si todos los elementos son del mismo tipo
    const allDishes = selectedElements.every(el => el.type === 'dish');
    const allProducts = selectedElements.every(el => el.type === 'product');

    if (allDishes) {
      // Todos son platos - detectar precios de platos
      this.detectCommonDishPrices(selectedElements);
    } else if (allProducts) {
      // Todos son productos - detectar precios de productos
      this.detectCommonProductPrices(selectedElements);
    } else {
      // Mezcla de tipos - no mostrar precios comunes
      this.massivePrice = null;
      this.massivePrice2 = null;
      this.massivePrice3 = null;
      this.massivePriceOnline = null;
    }
  }

  // Detectar precios comunes de platos
  private detectCommonDishPrices(selectedElements: any[]) {
    // Precio principal
    const prices = selectedElements.map(el => el && el.price !== undefined && el.price !== null ? el.price : null);
    const validPrices = prices.filter(price => price !== null && price !== undefined && price !== '');
    const uniquePrices = validPrices.filter((price, index) => validPrices.indexOf(price) === index);
    this.massivePrice = uniquePrices.length === 1 ? uniquePrices[0] : null;

    // Precio mitad
    const prices2 = selectedElements.map(el => el && el.price_half !== undefined && el.price_half !== null ? el.price_half : null);
    const validPrices2 = prices2.filter(price => price !== null && price !== undefined && price !== '');
    const uniquePrices2 = validPrices2.filter((price, index) => validPrices2.indexOf(price) === index);
    this.massivePrice2 = uniquePrices2.length === 1 ? uniquePrices2[0] : null;

    // Precio tapa
    const prices3 = selectedElements.map(el => el && el.price_tapa !== undefined && el.price_tapa !== null ? el.price_tapa : null);
    const validPrices3 = prices3.filter(price => price !== null && price !== undefined && price !== '');
    const uniquePrices3 = validPrices3.filter((price, index) => validPrices3.indexOf(price) === index);
    this.massivePrice3 = uniquePrices3.length === 1 ? uniquePrices3[0] : null;

    // Precio takeaway
    const pricesOnline = selectedElements.map(el => el && el.price_takeaway !== undefined && el.price_takeaway !== null ? el.price_takeaway : null);
    const validPricesOnline = pricesOnline.filter(price => price !== null && price !== undefined && price !== '');
    const uniquePricesOnline = validPricesOnline.filter((price, index) => validPricesOnline.indexOf(price) === index);
    this.massivePriceOnline = uniquePricesOnline.length === 1 ? uniquePricesOnline[0] : null;
  }

  // Detectar precios comunes de productos
  private detectCommonProductPrices(selectedElements: any[]) {
    // Precio principal
    const prices = selectedElements.map(el => el && el.pvp !== undefined && el.pvp !== null ? el.pvp : null);
    const validPrices = prices.filter(price => price !== null && price !== undefined && price !== '');
    const uniquePrices = validPrices.filter((price, index) => validPrices.indexOf(price) === index);
    this.massivePrice = uniquePrices.length === 1 ? uniquePrices[0] : null;

    // Precio 2
    const prices2 = selectedElements.map(el => el && el.pvp2 !== undefined && el.pvp2 !== null ? el.pvp2 : null);
    const validPrices2 = prices2.filter(price => price !== null && price !== undefined && price !== '');
    const uniquePrices2 = validPrices2.filter((price, index) => validPrices2.indexOf(price) === index);
    this.massivePrice2 = uniquePrices2.length === 1 ? uniquePrices2[0] : null;

    // Precio 3
    const prices3 = selectedElements.map(el => el && el.pvp3 !== undefined && el.pvp3 !== null ? el.pvp3 : null);
    const validPrices3 = prices3.filter(price => price !== null && price !== undefined && price !== '');
    const uniquePrices3 = validPrices3.filter((price, index) => validPrices3.indexOf(price) === index);
    this.massivePrice3 = uniquePrices3.length === 1 ? uniquePrices3[0] : null;

    // Precio takeaway
    const pricesOnline = selectedElements.map(el => el && el.pvp_takeaway !== undefined && el.pvp_takeaway !== null ? el.pvp_takeaway : null);
    const validPricesOnline = pricesOnline.filter(price => price !== null && price !== undefined && price !== '');
    const uniquePricesOnline = validPricesOnline.filter((price, index) => validPricesOnline.indexOf(price) === index);
    this.massivePriceOnline = uniquePricesOnline.length === 1 ? uniquePricesOnline[0] : null;
  }

  // Limpiar controles de modificación masiva
  private clearMassiveControls() {
    this.massiveColor = null;
    this.massiveSelectedCategories = [];
    this.massiveRemovedCategories = [];
    this.massiveSelectedComplements = [];
    this.massiveRemovedComplements = [];
    this.massivePosActive = null;
    this.massiveFavourite = null;
    this.massivePrice = null;
    this.massivePrice2 = null;
    this.massivePrice3 = null;
    this.massivePriceOnline = null;
    this.hasCommonValuesDetected = false;
    this.lastSelectedCount = 0;
    this.manualChangesMade = false;
  }

  // Métodos para manejo masivo de categorías
  searchMassiveCategories(searchValue: string) {
    // Obtener todas las categorías únicas de todos los artículos
    const allCategories = new Set<string>();
    this.elements_working.forEach(item => {
      if (item.tags && item.tags.length > 0) {
        item.tags.forEach((tag: string) => allCategories.add(tag));
      }
    });

    const categoriesList = Array.from(allCategories).sort();

    if (!searchValue || searchValue.trim() === '') {
      // Si no hay texto de búsqueda, mostrar todas las categorías disponibles
      this.massiveCategorySearchResults = categoriesList.filter(category => {
        return this.massiveSelectedCategories.indexOf(category) === -1;
      });
      return;
    }

    // Filtrar categorías que coincidan con la búsqueda
    const filteredCategories = categoriesList.filter(category =>
      category.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1
    );

    // Excluir categorías que ya están seleccionadas
    this.massiveCategorySearchResults = filteredCategories.filter(category => {
      return this.massiveSelectedCategories.indexOf(category) === -1;
    });

    // Limitar a 2 resultados para el dropdown
    this.massiveCategorySearchResults = this.massiveCategorySearchResults.slice(0, 2);
  }

  addMassiveCategory() {
    if (!this.massiveCategories || this.massiveCategories.trim() === '') {
      return;
    }

    // Buscar coincidencia exacta en los resultados de búsqueda
    const exactMatch = this.massiveCategorySearchResults.find(category =>
      category.toLowerCase() === this.massiveCategories.toLowerCase()
    );

    if (exactMatch) {
      this.addMassiveCategoryFromList(exactMatch);
    } else {
      // Si no hay coincidencia exacta, añadir la categoría como nueva
      this.addMassiveCategoryFromList(this.massiveCategories.trim());
    }
  }

  addMassiveCategoryFromList(category: string) {
    // Añadir a la lista de categorías seleccionadas masivamente
    if (this.massiveSelectedCategories.indexOf(category) === -1) {
      this.massiveSelectedCategories.push(category);
    }

    // Limpiar búsqueda y cerrar dropdown
    this.massiveCategories = '';
    this.massiveCategorySearchResults = [];

    // Marcar que se han hecho cambios manuales para evitar que se sobrescriban
    this.hasCommonValuesDetected = true;
    this.manualChangesMade = true;
  }

  removeMassiveCategory(category: string) {
    const index = this.massiveSelectedCategories.indexOf(category);
    if (index > -1) {
      this.massiveSelectedCategories.splice(index, 1);
      // Añadir a la lista de categorías removidas
      if (this.massiveRemovedCategories.indexOf(category) === -1) {
        this.massiveRemovedCategories.push(category);
      }
      // Marcar que se han hecho cambios manuales para evitar que se sobrescriban
      this.hasCommonValuesDetected = true;
      this.manualChangesMade = true;
    }
  }

  // Métodos para manejo masivo de complementos
  searchMassiveComplements(searchValue: string) {
    // Verificar que los grupos de complementos estén disponibles
    if (!this.configurationServices.complements_group_array) {
      this.configurationServices.getComplementsGroups();
      this.massiveComplementSearchResults = [];
      return;
    }

    if (this.configurationServices.complements_group_array.length === 0) {
      this.massiveComplementSearchResults = [];
      return;
    }

    if (!searchValue || searchValue.trim() === '') {
      // Si no hay texto de búsqueda, mostrar todos los grupos disponibles
      const availableGroups = this.configurationServices.complements_group_array.filter((group: any) => {
        return !this.massiveSelectedComplements.some((selected: any) => selected.uid === group.UID);
      });

      // Crear objetos con las propiedades necesarias para el dropdown - mostrar todos los grupos
      this.massiveComplementSearchResults = availableGroups.map((group: any) => ({
        ...group,
        name_static: this.globals.nameNotEsLang(group),
        description_static: group.description || group.desc || ''
      }));
      return;
    }

    // Filtrar grupos de complementos que coincidan con la búsqueda
    const filteredGroups = this.configurationServices.complements_group_array.filter((group: any) => {
      const groupName = this.globals.nameNotEsLang(group).toLowerCase();
      return groupName.indexOf(searchValue.toLowerCase()) !== -1;
    });

    // Excluir grupos que ya están seleccionados
    const availableGroups = filteredGroups.filter((group: any) => {
      return !this.massiveSelectedComplements.some((selected: any) => selected.uid === group.UID);
    });

    // Crear objetos con las propiedades necesarias para el dropdown - limitar a 2 en búsqueda
    this.massiveComplementSearchResults = availableGroups.slice(0, 2).map((group: any) => ({
      ...group,
      name_static: this.globals.nameNotEsLang(group),
      description_static: group.description || group.desc || ''
    }));
  }

  selectMassiveComplement(group: any) {
    // Verificar si el grupo ya está seleccionado
    const alreadySelected = this.massiveSelectedComplements.some((selected: any) => selected.uid === group.UID);
    if (!alreadySelected) {
      // Añadir el grupo de complementos
      this.massiveSelectedComplements.push({
        uid: group.UID,
        pos_active: true,
        tk_active: false,
        name_static: group.name_static || this.globals.nameNotEsLang(group),
        type_static: 'group'
      });

      // Marcar que se han hecho cambios manuales para evitar que se sobrescriban
      this.hasCommonValuesDetected = true;
      this.manualChangesMade = true;
    }

    // Limpiar búsqueda y cerrar dropdown
    this.massiveComplements = '';
    this.massiveComplementSearchResults = [];
  }

  removeMassiveComplement(complement: any) {
    const index = this.massiveSelectedComplements.findIndex((c: any) => c.uid === complement.uid);
    if (index > -1) {
      this.massiveSelectedComplements.splice(index, 1);
      // Añadir a la lista de complementos removidos
      if (!this.massiveRemovedComplements.some((c: any) => c.uid === complement.uid)) {
        this.massiveRemovedComplements.push(complement);
      }
      // Marcar que se han hecho cambios manuales para evitar que se sobrescriban
      this.hasCommonValuesDetected = true;
      this.manualChangesMade = true;
    }
  }

  applyMassiveComplements() {
    if (!this.massiveComplements || this.massiveComplements.trim() === '') {
      return;
    }

    // Buscar el primer grupo que coincida exactamente
    const exactMatch = this.configurationServices.complements_group_array.find((group: any) => {
      const groupName = this.globals.nameNotEsLang(group).toLowerCase();
      return groupName === this.massiveComplements.toLowerCase();
    });

    if (exactMatch) {
      this.selectMassiveComplement(exactMatch);
    } else if (this.massiveComplementSearchResults && this.massiveComplementSearchResults.length > 0) {
      // Si no hay coincidencia exacta, seleccionar el primer resultado
      this.selectMassiveComplement(this.massiveComplementSearchResults[0]);
    }
  }

  applyMassiveSelectedComplements() {
    const selectedElements = this.elements_working.filter(e => e.selected);

    if (selectedElements.length === 0) {
      return;
    }

    selectedElements.forEach(element => {
      if (!element.variations_favourite) {
        element.variations_favourite = [];
      }

      // Primero, eliminar los complementos que han sido removidos manualmente
      if (this.massiveRemovedComplements && this.massiveRemovedComplements.length > 0) {
        element.variations_favourite = element.variations_favourite.filter(complement =>
          !this.massiveRemovedComplements.some(removedComplement => removedComplement.uid === complement.uid)
        );
      }

      // Luego, añadir los complementos seleccionados masivamente (si no están ya)
      if (this.massiveSelectedComplements && this.massiveSelectedComplements.length > 0) {
        this.massiveSelectedComplements.forEach(massiveComplement => {
          const alreadyExists = element.variations_favourite.some(existingComplement =>
            existingComplement.uid === massiveComplement.uid
          );
          if (!alreadyExists) {
            element.variations_favourite.push({
              uid: massiveComplement.uid,
              pos_active: massiveComplement.pos_active !== undefined ? massiveComplement.pos_active : true,
              tk_active: massiveComplement.tk_active !== undefined ? massiveComplement.tk_active : false,
              name_static: massiveComplement.name_static || '',
              type_static: massiveComplement.type_static || 'group'
            });
          }
        });
      }
    });
  }

  applyMassiveSelectedCategories() {
    const selectedElements = this.elements_working.filter(e => e.selected);

    selectedElements.forEach(element => {
      if (!element.tags) {
        element.tags = [];
      }

      // Primero, eliminar las categorías que han sido removidas manualmente
      if (this.massiveRemovedCategories && this.massiveRemovedCategories.length > 0) {
        element.tags = element.tags.filter(tag =>
          this.massiveRemovedCategories.indexOf(tag) === -1
        );
      }

      // Luego, añadir las categorías seleccionadas masivamente (si no están ya)
      if (this.massiveSelectedCategories && this.massiveSelectedCategories.length > 0) {
        this.massiveSelectedCategories.forEach(category => {
          if (element.tags.indexOf(category) === -1) {
            element.tags.push(category);
          }
        });
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/articles/articles-update-prices/articles-update-prices.ts